import { Mail, Linkedin, Clock } from "lucide-react";
import { SITE } from "@/data/site";
import { PageHero } from "@/components/Blocks";
import { Reveal } from "@/components/motion";
import ContactForm from "@/components/forms/ContactForm";
import { useSeo } from "@/lib/seo";

export default function ContactPage() {
  useSeo("Contact", "Tell SparkIdea Interactive what you're building. Start a project, discuss fractional CTO support, or explore a venture partnership.");
  return (
    <>
      <PageHero testId="contact-hero" eyebrow="Contact" title="Tell us what you're building."
        intro="Share where you are and what you need. We'll read every message and reply with a practical next step." />
      <section className="border-t border-si-line py-16 sm:py-24">
        <div className="wrap grid gap-12 lg:grid-cols-12">
          <Reveal className="panel p-6 sm:p-10 lg:col-span-8"><ContactForm /></Reveal>
          <aside className="space-y-4 lg:col-span-4">
            <Reveal delay={0.1} className="panel p-6">
              <Mail className="h-5 w-5 text-si-cyan" />
              <p className="mt-4 text-sm text-si-muted">Prefer email?</p>
              <a href={`mailto:${SITE.email}`} className="mt-1 block text-lg font-bold hover:text-si-cyan" data-testid="contact-email-link">{SITE.email}</a>
            </Reveal>
            <Reveal delay={0.15} className="panel p-6">
              <Linkedin className="h-5 w-5 text-si-cyan" />
              <p className="mt-4 text-sm text-si-muted">Connect with the founder</p>
              <a href={SITE.linkedin} target="_blank" rel="noopener noreferrer" className="mt-1 block text-lg font-bold hover:text-si-cyan" data-testid="contact-linkedin-link">Baltej Singh on LinkedIn</a>
            </Reveal>
            <Reveal delay={0.2} className="panel p-6">
              <Clock className="h-5 w-5 text-si-cyan" />
              <p className="mt-4 text-base text-si-muted">Looking to co-build a venture? Use the <a href="/venture-partnerships#apply" className="font-semibold text-si-text underline underline-offset-4 hover:text-si-cyan">partnership application</a> instead — it asks the questions we'll need.</p>
            </Reveal>
          </aside>
        </div>
      </section>
    </>
  );
}
